// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data-content-pane__literal {
  white-space: pre-wrap;
}

div.data-content-pane {
  border-top: solid 1px var(--color-data-pane-border-top, black);
  border-left: solid 1px var(--color-data-pane-border-top, black);
  border-bottom: solid 1px var(--color-data-pane-border-side, #777);
  border-right: solid 1px var(--color-data-pane-border-side, #777);
  padding: var(--spacing-base, 0.5rem);
  margin-top: var(--spacing-base, 0.5rem);
  margin-bottom: var(--spacing-base, 0.5rem);
}

div.data-content-pane table.data-content-pane__table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

div.data-content-pane table.data-content-pane__table--root {
  table-layout: auto;
}

div.data-content-pane .data-content-pane__row--root {
  display: flex;
  align-items: flex-start;
}

div.data-content-pane .data-content-pane__row--root > td {
  vertical-align: top;
}

div.data-content-pane .data-content-pane__subject-cell {
  flex: 0 0 auto;
  width: clamp(7rem, 12%, 10rem);
  padding-right: 0.8rem;
}

div.data-content-pane .data-content-pane__details-cell {
  flex: 0 1 auto;
  min-width: 0;
}

div.data-content-pane .data-content-pane__subject-cell,
div.data-content-pane td.data-content-pane__predicate-cell,
div.data-content-pane .data-content-pane__row--top-aligned > td:not(.data-content-pane__predicate-cell),
div.data-content-pane .data-content-pane__subject-cell a,
div.data-content-pane td.data-content-pane__predicate-cell a,
div.data-content-pane .data-content-pane__row--top-aligned > td:not(.data-content-pane__predicate-cell) a {
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

div.data-content-pane table.data-content-pane__table--property {
  table-layout: auto;
  width: auto;
  max-width: 100%;
}

.data-content-pane__nested-formula {
  border-top: solid 1px var(--color-data-pane-border-top, black);
  border-left: solid 1px var(--color-data-pane-border-top, black);
  border-bottom: solid 1px var(--color-data-pane-border-side, #777);
  border-right: solid 1px var(--color-data-pane-border-side, #777);
  padding: var(--spacing-base, 0.5rem);
  border-radius: var(--border-radius-md, 0.5rem);
}

div.data-content-pane td {
  padding-left: var(--spacing-xxxs, 0.2rem);
  padding-top: var(--spacing-small, 0.1rem);
  padding-right: var(--spacing-xxxs, 0.2rem);
  padding-bottom: 0.05rem;
  vertical-align: top;
}

div.data-content-pane table.data-content-pane__table--property td {
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
}

div.data-content-pane tr {
  margin-bottom: var(--spacing-2xs, 0.625rem);
  padding-top: var(--spacing-small, 0.1rem);
  padding-bottom: var(--spacing-small, 0.1rem);
}

.data-content-pane a {
  color: var(--color-text-link, #3b5998);
  text-decoration: none;
  font-weight: bold;
}

.data-content-pane a:link {
  color: var(--color-text-link, #3b5998);
  text-decoration: none;
  font-weight: bold;
}

.data-content-pane a:visited {
  color: var(--color-text-link-visited, #3b5998);
  text-decoration: none;
  font-weight: bold;
}

.data-content-pane a:hover {
  color: var(--color-text-link-hover, #3b5998);
  text-decoration: underline;
  font-weight: bold;
}

.data-content-pane a:active {
  color: var(--color-text-link-active, #888);
  text-decoration: none;
}

.data-content-pane.embeddedText {
  white-space: pre-wrap;
}

div.data-content-pane td.data-content-pane__predicate-cell {
  min-width: 8.5rem;
  width: clamp(8.5rem, 18vw, 12rem);
  max-width: 12rem;
  padding-right: var(--spacing-base, 0.5rem);
}

div.data-content-pane .data-content-pane__row--top-aligned > td:not(.data-content-pane__predicate-cell) {
  padding-left: var(--spacing-xxs, 0.3125rem);
}

div.data-content-pane td.data-content-pane__predicate-cell a {
  color: var(--color-text-muted, #444);
}

.data-content-pane__row--even {
  background-color: var(--color-background-row-alternate, #f0f0f0);
}

.data-content-pane__row--odd {
  background-color: var(--color-background-row-default, white);
}

.data-content-pane__row--top-aligned {
  vertical-align: top;
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 0;
}

.data-content-pane__nested-table--light {
  background-color: var(--color-background-row-default, white);
}

.data-content-pane__nested-table--dark {
  background-color: var(--color-background-row-alternate, #f0f0f0);
}

div.data-content-pane[data-layout='mobile'] .data-content-pane__row--root {
  display: flex;
  align-items: flex-start;
  padding-bottom: var(--spacing-xs, 0.75rem);
}

div.data-content-pane[data-layout='mobile'] .data-content-pane__subject-cell {
  flex: 0 0 40%;
  width: 40%;
  max-width: 40%;
  box-sizing: border-box;
  padding-right: var(--spacing-xs, 0.75rem);
  padding-bottom: 0;
}

div.data-content-pane[data-layout='mobile'] .data-content-pane__details-cell {
  flex: 0 0 60%;
  width: 60%;
  max-width: 60%;
  min-width: 0;
  box-sizing: border-box;
}

div.data-content-pane[data-layout='mobile'] table.data-content-pane__table--property > tbody > tr,
div.data-content-pane[data-layout='mobile'] table.data-content-pane__table--property > tr {
  margin-bottom: 0;
}

div.data-content-pane[data-layout='mobile'] .data-content-pane__row--top-aligned + .data-content-pane__row--top-aligned {
  margin-top: 0;
}

div.data-content-pane[data-layout='mobile'] .data-content-pane__row--top-aligned {
  display: block;
  margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 0;
}

div.data-content-pane[data-layout='mobile'] table.data-content-pane__table--property,
div.data-content-pane[data-layout='mobile'] table.data-content-pane__table--property > tbody {
  display: block;
  width: 100%;
}

div.data-content-pane[data-layout='mobile'] table.data-content-pane__table--property td {
  display: block;
  width: 100%;
  box-sizing: border-box;
}

div.data-content-pane[data-layout='mobile'] table.data-content-pane__table--property td.data-content-pane__predicate-cell {
  width: 100%;
  min-width: 0;
  padding-bottom: 0.1rem;
}

div.data-content-pane[data-layout='mobile'] table.data-content-pane__table--property td:not(.data-content-pane__predicate-cell) {
  padding-top: 0;
  padding-left: 0.85rem;
}

@media (max-width: 700px) {
  div.data-content-pane .data-content-pane__row--root {
    display: flex;
    align-items: flex-start;
  }

  div.data-content-pane .data-content-pane__subject-cell {
    flex: 0 0 40%;
    width: 40%;
    max-width: 40%;
    padding-right: var(--spacing-xs, 0.75rem);
    padding-bottom: 0;
    box-sizing: border-box;
  }

  div.data-content-pane .data-content-pane__details-cell {
    flex: 0 0 60%;
    width: 60%;
    max-width: 60%;
    box-sizing: border-box;
  }

  div.data-content-pane .data-content-pane__row--top-aligned {
    display: block;
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 0;
    padding-bottom: 0;
  }

  div.data-content-pane .data-content-pane__row--top-aligned > td {
    display: block;
    width: 100%;
    box-sizing: border-box;
  }

  div.data-content-pane .data-content-pane__row--top-aligned > td.data-content-pane__predicate-cell {
    min-width: 0;
    max-width: none;
    width: 100%;
    padding-bottom: var(--spacing-small, 0.1rem);
  }

  div.data-content-pane .data-content-pane__row--top-aligned > td:not(.data-content-pane__predicate-cell) {
    padding-top: 0;
    padding-left: 0.85rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/dataContentPane.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,8DAA8D;EAC9D,+DAA+D;EAC/D,iEAAiE;EACjE,gEAAgE;EAChE,oCAAoC;EACpC,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;;;;;;EAME,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,8DAA8D;EAC9D,+DAA+D;EAC/D,iEAAiE;EACjE,gEAAgE;EAChE,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,0CAA0C;EAC1C,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;EAC9C,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;EAC5C,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,UAAU;EACV,cAAc;EACd,sBAAsB;EACtB,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,cAAc;EACd,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,cAAc;IACd,yCAAyC;IACzC,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,WAAW;IACX,4CAA4C;EAC9C;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;AACF","sourcesContent":[".data-content-pane__literal {\n  white-space: pre-wrap;\n}\n\ndiv.data-content-pane {\n  border-top: solid 1px var(--color-data-pane-border-top, black);\n  border-left: solid 1px var(--color-data-pane-border-top, black);\n  border-bottom: solid 1px var(--color-data-pane-border-side, #777);\n  border-right: solid 1px var(--color-data-pane-border-side, #777);\n  padding: var(--spacing-base, 0.5rem);\n  margin-top: var(--spacing-base, 0.5rem);\n  margin-bottom: var(--spacing-base, 0.5rem);\n}\n\ndiv.data-content-pane table.data-content-pane__table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\ndiv.data-content-pane table.data-content-pane__table--root {\n  table-layout: auto;\n}\n\ndiv.data-content-pane .data-content-pane__row--root {\n  display: flex;\n  align-items: flex-start;\n}\n\ndiv.data-content-pane .data-content-pane__row--root > td {\n  vertical-align: top;\n}\n\ndiv.data-content-pane .data-content-pane__subject-cell {\n  flex: 0 0 auto;\n  width: clamp(7rem, 12%, 10rem);\n  padding-right: 0.8rem;\n}\n\ndiv.data-content-pane .data-content-pane__details-cell {\n  flex: 0 1 auto;\n  min-width: 0;\n}\n\ndiv.data-content-pane .data-content-pane__subject-cell,\ndiv.data-content-pane td.data-content-pane__predicate-cell,\ndiv.data-content-pane .data-content-pane__row--top-aligned > td:not(.data-content-pane__predicate-cell),\ndiv.data-content-pane .data-content-pane__subject-cell a,\ndiv.data-content-pane td.data-content-pane__predicate-cell a,\ndiv.data-content-pane .data-content-pane__row--top-aligned > td:not(.data-content-pane__predicate-cell) a {\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\ndiv.data-content-pane table.data-content-pane__table--property {\n  table-layout: auto;\n  width: auto;\n  max-width: 100%;\n}\n\n.data-content-pane__nested-formula {\n  border-top: solid 1px var(--color-data-pane-border-top, black);\n  border-left: solid 1px var(--color-data-pane-border-top, black);\n  border-bottom: solid 1px var(--color-data-pane-border-side, #777);\n  border-right: solid 1px var(--color-data-pane-border-side, #777);\n  padding: var(--spacing-base, 0.5rem);\n  border-radius: var(--border-radius-md, 0.5rem);\n}\n\ndiv.data-content-pane td {\n  padding-left: var(--spacing-xxxs, 0.2rem);\n  padding-top: var(--spacing-small, 0.1rem);\n  padding-right: var(--spacing-xxxs, 0.2rem);\n  padding-bottom: 0.05rem;\n  vertical-align: top;\n}\n\ndiv.data-content-pane table.data-content-pane__table--property td {\n  padding-top: 0.3rem;\n  padding-bottom: 0.3rem;\n}\n\ndiv.data-content-pane tr {\n  margin-bottom: var(--spacing-2xs, 0.625rem);\n  padding-top: var(--spacing-small, 0.1rem);\n  padding-bottom: var(--spacing-small, 0.1rem);\n}\n\n.data-content-pane a {\n  color: var(--color-text-link, #3b5998);\n  text-decoration: none;\n  font-weight: bold;\n}\n\n.data-content-pane a:link {\n  color: var(--color-text-link, #3b5998);\n  text-decoration: none;\n  font-weight: bold;\n}\n\n.data-content-pane a:visited {\n  color: var(--color-text-link-visited, #3b5998);\n  text-decoration: none;\n  font-weight: bold;\n}\n\n.data-content-pane a:hover {\n  color: var(--color-text-link-hover, #3b5998);\n  text-decoration: underline;\n  font-weight: bold;\n}\n\n.data-content-pane a:active {\n  color: var(--color-text-link-active, #888);\n  text-decoration: none;\n}\n\n.data-content-pane.embeddedText {\n  white-space: pre-wrap;\n}\n\ndiv.data-content-pane td.data-content-pane__predicate-cell {\n  min-width: 8.5rem;\n  width: clamp(8.5rem, 18vw, 12rem);\n  max-width: 12rem;\n  padding-right: var(--spacing-base, 0.5rem);\n}\n\ndiv.data-content-pane .data-content-pane__row--top-aligned > td:not(.data-content-pane__predicate-cell) {\n  padding-left: var(--spacing-xxs, 0.3125rem);\n}\n\ndiv.data-content-pane td.data-content-pane__predicate-cell a {\n  color: var(--color-text-muted, #444);\n}\n\n.data-content-pane__row--even {\n  background-color: var(--color-background-row-alternate, #f0f0f0);\n}\n\n.data-content-pane__row--odd {\n  background-color: var(--color-background-row-default, white);\n}\n\n.data-content-pane__row--top-aligned {\n  vertical-align: top;\n  margin-top: 0;\n  margin-bottom: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.data-content-pane__nested-table--light {\n  background-color: var(--color-background-row-default, white);\n}\n\n.data-content-pane__nested-table--dark {\n  background-color: var(--color-background-row-alternate, #f0f0f0);\n}\n\ndiv.data-content-pane[data-layout='mobile'] .data-content-pane__row--root {\n  display: flex;\n  align-items: flex-start;\n  padding-bottom: var(--spacing-xs, 0.75rem);\n}\n\ndiv.data-content-pane[data-layout='mobile'] .data-content-pane__subject-cell {\n  flex: 0 0 40%;\n  width: 40%;\n  max-width: 40%;\n  box-sizing: border-box;\n  padding-right: var(--spacing-xs, 0.75rem);\n  padding-bottom: 0;\n}\n\ndiv.data-content-pane[data-layout='mobile'] .data-content-pane__details-cell {\n  flex: 0 0 60%;\n  width: 60%;\n  max-width: 60%;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\ndiv.data-content-pane[data-layout='mobile'] table.data-content-pane__table--property > tbody > tr,\ndiv.data-content-pane[data-layout='mobile'] table.data-content-pane__table--property > tr {\n  margin-bottom: 0;\n}\n\ndiv.data-content-pane[data-layout='mobile'] .data-content-pane__row--top-aligned + .data-content-pane__row--top-aligned {\n  margin-top: 0;\n}\n\ndiv.data-content-pane[data-layout='mobile'] .data-content-pane__row--top-aligned {\n  display: block;\n  margin-bottom: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\ndiv.data-content-pane[data-layout='mobile'] table.data-content-pane__table--property,\ndiv.data-content-pane[data-layout='mobile'] table.data-content-pane__table--property > tbody {\n  display: block;\n  width: 100%;\n}\n\ndiv.data-content-pane[data-layout='mobile'] table.data-content-pane__table--property td {\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n}\n\ndiv.data-content-pane[data-layout='mobile'] table.data-content-pane__table--property td.data-content-pane__predicate-cell {\n  width: 100%;\n  min-width: 0;\n  padding-bottom: 0.1rem;\n}\n\ndiv.data-content-pane[data-layout='mobile'] table.data-content-pane__table--property td:not(.data-content-pane__predicate-cell) {\n  padding-top: 0;\n  padding-left: 0.85rem;\n}\n\n@media (max-width: 700px) {\n  div.data-content-pane .data-content-pane__row--root {\n    display: flex;\n    align-items: flex-start;\n  }\n\n  div.data-content-pane .data-content-pane__subject-cell {\n    flex: 0 0 40%;\n    width: 40%;\n    max-width: 40%;\n    padding-right: var(--spacing-xs, 0.75rem);\n    padding-bottom: 0;\n    box-sizing: border-box;\n  }\n\n  div.data-content-pane .data-content-pane__details-cell {\n    flex: 0 0 60%;\n    width: 60%;\n    max-width: 60%;\n    box-sizing: border-box;\n  }\n\n  div.data-content-pane .data-content-pane__row--top-aligned {\n    display: block;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  div.data-content-pane .data-content-pane__row--top-aligned > td {\n    display: block;\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  div.data-content-pane .data-content-pane__row--top-aligned > td.data-content-pane__predicate-cell {\n    min-width: 0;\n    max-width: none;\n    width: 100%;\n    padding-bottom: var(--spacing-small, 0.1rem);\n  }\n\n  div.data-content-pane .data-content-pane__row--top-aligned > td:not(.data-content-pane__predicate-cell) {\n    padding-top: 0;\n    padding-left: 0.85rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
